// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Event Card Styles */

.event-card--past {
  opacity: 0.55;
  filter: grayscale(0.3);
}

.tavern-card--event.event-card--past:hover {
  transform: none;
  box-shadow: none;
}

.event-card-header-content {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
  width: 100%;
}

/* Event description */
.event-card-description {
  margin-bottom: var(--space-3);
}

/* Embedded game card inside event */
.event-card-game {
  margin-bottom: var(--space-3);
}

.event-card-info {
  flex: 1;
  min-width: 0;
}

.event-card-organizer-me {
  font-size: 13px;
  color: var(--color-text-secondary);
}

.event-card-organizer-link {
  font-size: 13px;
  font-weight: 600;
  color: var(--color-fire-600);
  text-decoration: none;
}

.event-card-organizer-link:hover {
  text-decoration: underline;
}

.event-card-actions {
  display: flex;
  gap: var(--space-2);
  flex-shrink: 0;
  margin-left: auto;
}

/* Participants count badge */
.event-participants-count {
  display: flex;
  align-items: center;
  gap: var(--space-2);
  padding: var(--space-2) var(--space-3);
  background: linear-gradient(135deg, var(--color-wood-700), var(--color-wood-600));
  border: 2px solid var(--color-wood-700);
  border-radius: var(--radius-lg);
  color: var(--color-parchment-100);
  font-weight: 600;
  font-size: 14px;
  box-shadow: 0 2px 4px rgba(26, 20, 16, 0.2);
  margin-left: auto;
}

.event-participants-icon {
  font-size: 16px;
  line-height: 1;
}

.event-participants-text {
  font-family: var(--font-heading);
}

/* Action buttons bar - below header */
.event-card-actions-bar {
  display: flex;
  gap: var(--space-2);
  padding: var(--space-3) 0;
  border-top: 2px solid var(--color-wood-600);
  margin-top: var(--space-3);
}

.event-action-bar-btn {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--space-2);
  padding: var(--space-2) var(--space-3);
  border-radius: var(--radius-lg);
  border: 2px solid;
  font-family: var(--font-body);
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all var(--transition-fast);
}

.event-action-bar-btn--invite {
  border-color: var(--color-fire-600);
  background: linear-gradient(135deg, var(--color-fire-100), var(--color-fire-200));
  color: var(--color-fire-800);
  box-shadow: 0 2px 4px rgba(212, 129, 74, 0.25);
}

.event-action-bar-btn--invite:hover {
  background: linear-gradient(135deg, var(--color-fire-200), var(--color-fire-300));
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(212, 129, 74, 0.35);
}

.event-action-bar-btn--invite svg {
  fill: var(--color-fire-700);
}

.event-action-bar-btn--edit {
  border-color: var(--color-wood-600);
  background: linear-gradient(135deg, #f5ede3, #e8dcc8);
  color: var(--color-wood-900);
  box-shadow: 0 2px 4px rgba(109, 76, 41, 0.25);
}

.event-action-bar-btn--edit:hover {
  background: linear-gradient(135deg, #e8dcc8, #d4c4a8);
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(109, 76, 41, 0.35);
}

.event-action-bar-btn--delete {
  border-color: #c99169;
  background: linear-gradient(135deg, #f7e8dd, #f0d9c5);
  color: #000000;
  box-shadow: 0 2px 4px rgba(139, 76, 41, 0.25);
}

.event-action-bar-btn--delete:hover {
  background: linear-gradient(135deg, #f0d9c5, #e8cbb0);
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(139, 76, 41, 0.35);
}

.event-action-bar-btn:active {
  transform: translateY(0);
}

.event-card-organizer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-3);
  margin-bottom: var(--space-3);
  padding: var(--space-2) 0;
  border-bottom: 1px solid var(--color-wood-600);
}

.event-card-organizer-main {
  display: flex;
  align-items: center;
  gap: var(--space-2);
  min-width: 0;
  flex: 1 1 auto;
}

.organizer-icon {
  font-size: 16px;
  line-height: 1;
  flex-shrink: 0;
}

.organizer-name {
  font-size: var(--font-size-body);
  font-weight: var(--font-weight-semibold);
  color: var(--color-text-primary);
  font-family: var(--font-body);
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.organizer-name--system {
  color: var(--color-fire-600);
}

.event-card-organizer a {
  font-size: var(--font-size-body);
  font-weight: var(--font-weight-semibold);
  font-family: var(--font-body);
  color: var(--color-fire-600);
  text-decoration: none;
  cursor: pointer;
  transition: color var(--transition-fast);
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.event-card-organizer a:hover {
  color: var(--color-fire-700);
  text-decoration: underline;
}

/* Participants list */
.event-card-participants {
  margin-top: var(--space-3);
}

.participants-header {
  font-size: 14px;
  font-weight: 600;
  color: var(--color-text-primary);
  margin-bottom: var(--space-2);
  padding: 0 var(--space-2);
}

.participants-list {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
}

.participant-item {
  display: flex;
  align-items: center;
  gap: var(--space-3);
  padding: 12px 16px;
  border-radius: 12px;
  background: var(--color-parchment-100);
  border: 2px solid var(--color-wood-600);
  box-shadow: 0 2px 4px rgba(45, 31, 16, 0.1);
  transition: all 0.2s ease;
}

.participant-item--confirmed {
  border-color: var(--color-wood-800);
  background: linear-gradient(135deg, #e8dcc8 0%, #d4c4a8 100%);
  box-shadow: 0 2px 8px rgba(109, 76, 41, 0.35);
}

.participant-item--pending {
  border-color: var(--color-warning-600);
  background: linear-gradient(135deg, #fdf8ed 0%, #fef5e7 100%);
  box-shadow: 0 2px 8px rgba(212, 167, 74, 0.2);
}

.participant-item--empty {
  background: var(--color-wood-50);
  border-color: var(--color-wood-500);
  border-style: dashed;
  color: var(--color-text-secondary);
  box-shadow: none;
}

.participant-item--joinable {
  cursor: pointer;
}

.participant-item--joinable:hover {
  background: linear-gradient(135deg, #e8f5ea 0%, #d4ead6 100%);
  border-color: var(--color-nature-700);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(74, 124, 89, 0.3);
}

.participant-icon {
  font-size: 20px;
  line-height: 1;
  flex-shrink: 0;
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(109, 76, 41, 0.15);
  border-radius: 50%;
  border: 2px solid var(--color-wood-700);
  color: var(--color-wood-900);
  font-weight: 900;
}

.participant-icon--empty {
  background: transparent;
  border: none;
  color: var(--color-wood-600);
}

.participant-name {
  flex: 1;
  min-width: 0;
  font-size: 15px;
  font-weight: 600;
  color: var(--color-text-primary);
  font-family: var(--font-body);
}

.participant-action-btn {
  padding: 6px 16px;
  font-size: 13px;
  font-weight: 700;
  color: var(--color-wood-900);
  background: #c4a570;
  border: 2px solid var(--color-wood-700);
  border-radius: 20px;
  cursor: pointer;
  transition: all 0.2s ease;
  font-family: var(--font-heading);
  box-shadow: 0 2px 6px rgba(109, 76, 41, 0.35);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.participant-action-icon {
  display: none;
}

.participant-action-btn:hover {
  background: var(--color-danger-100);
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(168, 52, 42, 0.3);
}

.participant-action-btn--confirm {
  color: var(--color-nature-900);
  border-color: var(--color-nature-500);
  background: #268d49;
  box-shadow: 0 2px 4px rgba(30, 105, 52, 0.3);
}

.participant-action-btn--confirm:hover {
  background: #166b32;
  box-shadow: 0 4px 8px rgba(8, 63, 24, 0.3);
}

.participant-action-btn--leave {
  border-color: var(--color-wood-700);
  background: linear-gradient(135deg, #f5ede3, #e8dcc8);
  color: var(--color-wood-900);
}

.participant-action-btn--leave:hover {
  background: linear-gradient(135deg, #e8dcc8, #d4c4a8);
}

/* Remove participant button (for organizers/admins) */
.participant-remove-btn {
  width: 28px;
  height: 28px;
  margin-left: auto;
  border-radius: 50%;
  border: 2px solid #8b2e0b;
  background: linear-gradient(135deg, #c53030, #a02020);
  color: #ffffff;
  font-size: 18px;
  font-weight: 900;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.8);
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.4);
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  flex-shrink: 0;
}

.participant-remove-btn:hover {
  background: linear-gradient(135deg, #a02020, #8b1a1a);
  transform: scale(1.1);
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.5);
}

.participant-remove-btn:active {
  transform: scale(0.95);
}

/* Invite button with AddFighterIcon */
.event-invite-btn {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 2px solid var(--color-fire-700);
  background: linear-gradient(135deg, var(--color-fire-100), var(--color-fire-200));
  color: var(--color-fire-800);
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  box-shadow: 0 2px 6px rgba(179, 111, 66, 0.35);
}

.event-invite-btn:hover {
  background: linear-gradient(135deg, var(--color-fire-200), var(--color-fire-300));
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(212, 129, 74, 0.5);
}

.event-invite-btn:active {
  transform: translateY(0);
}

.event-invite-btn svg {
  fill: var(--color-fire-700);
}

/* Copy-link button */
.event-copy-link-btn {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 2px solid var(--color-wood-600);
  background: linear-gradient(135deg, #f5ede3, #e8dcc8);
  color: var(--color-wood-900);
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  box-shadow: 0 2px 6px rgba(109, 76, 41, 0.35);
}

.event-copy-link-btn:hover {
  background: linear-gradient(135deg, #e8dcc8, #d4c4a8);
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(109, 76, 41, 0.5);
}

.event-copy-link-btn:active {
  transform: translateY(0);
}

/* Edit button */
.event-edit-btn {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 2px solid var(--color-wood-600);
  background: linear-gradient(135deg, #f5ede3, #e8dcc8);
  color: var(--color-wood-900);
  font-size: 20px;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  box-shadow: 0 2px 6px rgba(109, 76, 41, 0.35);
}

.event-edit-btn:hover {
  background: linear-gradient(135deg, #e8dcc8, #d4c4a8);
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(109, 76, 41, 0.5);
}

.event-edit-btn:active {
  transform: translateY(0);
}

/* Delete button */
.event-delete-btn {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 2px solid #e96609;
  background: linear-gradient(135deg, #f7e8dd, #f0d9c5);
  color: #000000;
  font-size: 18px;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  box-shadow: 0 2px 6px rgbattbFormHeaderTitle(139, 76, 41, 0.35);
}

.event-delete-btn:hover {
  background: linear-gradient(135deg, #f0d9c5, #e8cbb0);
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(139, 76, 41, 0.5);
}

.event-delete-btn:active {
  transform: translateY(0);
}

@media (max-width: 425px) {
  .event-card-header-content {
    gap: var(--space-1);
  }

  .event-card-actions {
    gap: 6px;
    flex: 1 1 auto;   
    margin-left: 0;
    justify-content: flex-end;
  }

  .event-copy-link-btn,
  .event-invite-btn,
  .event-edit-btn,
  .event-delete-btn {
    width: 32px;
    height: 32px;
    border-width: 1px;
  }

  .event-copy-link-btn svg,
  .event-invite-btn svg {
    width: 18px;
    height: 18px;
  }

  .event-edit-btn {
    font-size: 16px;
  }

  .event-delete-btn {
    font-size: 14px;
  }

  .event-card-organizer {
    margin-bottom: var(--space-2);
    padding: var(--space-1) 0;
  }

  .organizer-name {
    font-size: var(--font-size-body-sm);
  }

  .participants-header {
    font-size: 12px;
    padding: 0 8px;
  }

  .participants-list {
    gap: 6px;
  }

  .participant-item {
    gap: 8px;
    padding: 8px 10px;
    border-width: 1px;
    border-radius: 10px;
    flex-wrap: nowrap;
  }

  .participant-icon {
    width: 22px;
    height: 22px;
    font-size: 16px;
    border-width: 1px;
  }

  .participant-name {
    font-size: 13px;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    flex: 1 1 auto;
  }

  .participant-action-btn {
    width: 32px;
    height: 32px;
    padding: 0;
    font-size: 14px;
    border-width: 1px;
    border-radius: 50%;
    box-shadow: 0 1px 3px rgba(109, 76, 41, 0.25);
    flex: 0 0 auto;
  }

  .participant-action-text {
    display: none;
  }

  .participant-action-icon {
    display: inline-block;
    line-height: 1;
  }

  .participant-remove-btn {
    width: 24px;
    height: 24px;
    font-size: 14px;
    border-width: 1px;
  }
}

/* ---------- Wide layout: info on the left, game and participants on the right ---------- */

/* Контейнер — только обёртка тела: container-type создаёт containing block для fixed-потомков,
   а шторы подтверждения/приглашения живут внутри самой карточки. */
.event-card-bodywrap {
  container-type: inline-size;
  container-name: event-card;
}

.event-card-col > :last-child {
  margin-bottom: 0;
}

@container event-card (min-width: 720px) {
  .event-card-body {
    display: grid;
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
    column-gap: var(--space-5);
    align-items: start;
  }
}
`, "",{"version":3,"sources":["webpack://./src/features/events/EventCard.css"],"names":[],"mappings":"AAAA,sBAAsB;;AAEtB;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;AACb;;AAEA,sBAAsB;AACtB;EACE,6BAA6B;AAC/B;;AAEA,oCAAoC;AACpC;EACE,6BAA6B;AAC/B;;AAEA;EACE,OAAO;EACP,YAAY;AACd;;AAEA;EACE,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,iBAAiB;AACnB;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,sCAAsC;EACtC,iFAAiF;EACjF,uCAAuC;EACvC,+BAA+B;EAC/B,iCAAiC;EACjC,gBAAgB;EAChB,eAAe;EACf,2CAA2C;EAC3C,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gCAAgC;AAClC;;AAEA,sCAAsC;AACtC;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,2CAA2C;EAC3C,0BAA0B;AAC5B;;AAEA;EACE,OAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,sCAAsC;EACtC,+BAA+B;EAC/B,iBAAiB;EACjB,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,mCAAmC;EACnC,iFAAiF;EACjF,4BAA4B;EAC5B,8CAA8C;AAChD;;AAEA;EACE,iFAAiF;EACjF,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,mCAAmC;EACnC,qDAAqD;EACrD,4BAA4B;EAC5B,6CAA6C;AAC/C;;AAEA;EACE,qDAAqD;EACrD,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,qBAAqB;EACrB,qDAAqD;EACrD,cAAc;EACd,6CAA6C;AAC/C;;AAEA;EACE,qDAAqD;EACrD,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,6BAA6B;EAC7B,yBAAyB;EACzB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,wCAAwC;EACxC,gCAAgC;EAChC,6BAA6B;EAC7B,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,gCAAgC;EAChC,wCAAwC;EACxC,6BAA6B;EAC7B,4BAA4B;EAC5B,qBAAqB;EACrB,eAAe;EACf,wCAAwC;EACxC,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,0BAA0B;AAC5B;;AAEA,sBAAsB;AACtB;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,sCAAsC;EACtC,uCAAuC;EACvC,2CAA2C;EAC3C,yBAAyB;AAC3B;;AAEA;EACE,mCAAmC;EACnC,6DAA6D;EAC7D,6CAA6C;AAC/C;;AAEA;EACE,sCAAsC;EACtC,6DAA6D;EAC7D,6CAA6C;AAC/C;;AAEA;EACE,gCAAgC;EAChC,mCAAmC;EACnC,oBAAoB;EACpB,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,6DAA6D;EAC7D,qCAAqC;EACrC,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;EACd,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mCAAmC;EACnC,kBAAkB;EAClB,uCAAuC;EACvC,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,mBAAmB;EACnB,uCAAuC;EACvC,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,gCAAgC;EAChC,6CAA6C;EAC7C,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mCAAmC;EACnC,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;EACE,8BAA8B;EAC9B,qCAAqC;EACrC,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,mCAAmC;EACnC,qDAAqD;EACrD,4BAA4B;AAC9B;;AAEA;EACE,qDAAqD;AACvD;;AAEA,sDAAsD;AACtD;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,qDAAqD;EACrD,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,yCAAyC;EACzC,wCAAwC;EACxC,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,qDAAqD;EACrD,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA;EACE,sBAAsB;AACxB;;AAEA,sCAAsC;AACtC;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,uCAAuC;EACvC,iFAAiF;EACjF,4BAA4B;EAC5B,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,8CAA8C;AAChD;;AAEA;EACE,iFAAiF;EACjF,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,qBAAqB;AACrB;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,uCAAuC;EACvC,qDAAqD;EACrD,4BAA4B;EAC5B,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,6CAA6C;AAC/C;;AAEA;EACE,qDAAqD;EACrD,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,gBAAgB;AAChB;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,uCAAuC;EACvC,qDAAqD;EACrD,4BAA4B;EAC5B,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,6CAA6C;AAC/C;;AAEA;EACE,qDAAqD;EACrD,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,kBAAkB;AAClB;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,qDAAqD;EACrD,cAAc;EACd,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,+DAA+D;AACjE;;AAEA;EACE,qDAAqD;EACrD,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,QAAQ;IACR,cAAc;IACd,cAAc;IACd,yBAAyB;EAC3B;;EAEA;;;;IAIE,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;;EAEA;;IAEE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,6BAA6B;IAC7B,yBAAyB;EAC3B;;EAEA;IACE,mCAAmC;EACrC;;EAEA;IACE,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;IACR,iBAAiB;IACjB,iBAAiB;IACjB,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,UAAU;IACV,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,6CAA6C;IAC7C,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,qBAAqB;IACrB,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;IACf,iBAAiB;EACnB;AACF;;AAEA,4FAA4F;;AAE5F;mEACmE;AACnE;EACE,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,aAAa;IACb,oDAAoD;IACpD,0BAA0B;IAC1B,kBAAkB;EACpB;AACF","sourcesContent":["/* Event Card Styles */\n\n.event-card--past {\n  opacity: 0.55;\n  filter: grayscale(0.3);\n}\n\n.tavern-card--event.event-card--past:hover {\n  transform: none;\n  box-shadow: none;\n}\n\n.event-card-header-content {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-2);\n  width: 100%;\n}\n\n/* Event description */\n.event-card-description {\n  margin-bottom: var(--space-3);\n}\n\n/* Embedded game card inside event */\n.event-card-game {\n  margin-bottom: var(--space-3);\n}\n\n.event-card-info {\n  flex: 1;\n  min-width: 0;\n}\n\n.event-card-organizer-me {\n  font-size: 13px;\n  color: var(--color-text-secondary);\n}\n\n.event-card-organizer-link {\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--color-fire-600);\n  text-decoration: none;\n}\n\n.event-card-organizer-link:hover {\n  text-decoration: underline;\n}\n\n.event-card-actions {\n  display: flex;\n  gap: var(--space-2);\n  flex-shrink: 0;\n  margin-left: auto;\n}\n\n/* Participants count badge */\n.event-participants-count {\n  display: flex;\n  align-items: center;\n  gap: var(--space-2);\n  padding: var(--space-2) var(--space-3);\n  background: linear-gradient(135deg, var(--color-wood-700), var(--color-wood-600));\n  border: 2px solid var(--color-wood-700);\n  border-radius: var(--radius-lg);\n  color: var(--color-parchment-100);\n  font-weight: 600;\n  font-size: 14px;\n  box-shadow: 0 2px 4px rgba(26, 20, 16, 0.2);\n  margin-left: auto;\n}\n\n.event-participants-icon {\n  font-size: 16px;\n  line-height: 1;\n}\n\n.event-participants-text {\n  font-family: var(--font-heading);\n}\n\n/* Action buttons bar - below header */\n.event-card-actions-bar {\n  display: flex;\n  gap: var(--space-2);\n  padding: var(--space-3) 0;\n  border-top: 2px solid var(--color-wood-600);\n  margin-top: var(--space-3);\n}\n\n.event-action-bar-btn {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: var(--space-2);\n  padding: var(--space-2) var(--space-3);\n  border-radius: var(--radius-lg);\n  border: 2px solid;\n  font-family: var(--font-body);\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all var(--transition-fast);\n}\n\n.event-action-bar-btn--invite {\n  border-color: var(--color-fire-600);\n  background: linear-gradient(135deg, var(--color-fire-100), var(--color-fire-200));\n  color: var(--color-fire-800);\n  box-shadow: 0 2px 4px rgba(212, 129, 74, 0.25);\n}\n\n.event-action-bar-btn--invite:hover {\n  background: linear-gradient(135deg, var(--color-fire-200), var(--color-fire-300));\n  transform: translateY(-1px);\n  box-shadow: 0 4px 8px rgba(212, 129, 74, 0.35);\n}\n\n.event-action-bar-btn--invite svg {\n  fill: var(--color-fire-700);\n}\n\n.event-action-bar-btn--edit {\n  border-color: var(--color-wood-600);\n  background: linear-gradient(135deg, #f5ede3, #e8dcc8);\n  color: var(--color-wood-900);\n  box-shadow: 0 2px 4px rgba(109, 76, 41, 0.25);\n}\n\n.event-action-bar-btn--edit:hover {\n  background: linear-gradient(135deg, #e8dcc8, #d4c4a8);\n  transform: translateY(-1px);\n  box-shadow: 0 4px 8px rgba(109, 76, 41, 0.35);\n}\n\n.event-action-bar-btn--delete {\n  border-color: #c99169;\n  background: linear-gradient(135deg, #f7e8dd, #f0d9c5);\n  color: #000000;\n  box-shadow: 0 2px 4px rgba(139, 76, 41, 0.25);\n}\n\n.event-action-bar-btn--delete:hover {\n  background: linear-gradient(135deg, #f0d9c5, #e8cbb0);\n  transform: translateY(-1px);\n  box-shadow: 0 4px 8px rgba(139, 76, 41, 0.35);\n}\n\n.event-action-bar-btn:active {\n  transform: translateY(0);\n}\n\n.event-card-organizer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: var(--space-3);\n  margin-bottom: var(--space-3);\n  padding: var(--space-2) 0;\n  border-bottom: 1px solid var(--color-wood-600);\n}\n\n.event-card-organizer-main {\n  display: flex;\n  align-items: center;\n  gap: var(--space-2);\n  min-width: 0;\n  flex: 1 1 auto;\n}\n\n.organizer-icon {\n  font-size: 16px;\n  line-height: 1;\n  flex-shrink: 0;\n}\n\n.organizer-name {\n  font-size: var(--font-size-body);\n  font-weight: var(--font-weight-semibold);\n  color: var(--color-text-primary);\n  font-family: var(--font-body);\n  flex: 1 1 auto;\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.organizer-name--system {\n  color: var(--color-fire-600);\n}\n\n.event-card-organizer a {\n  font-size: var(--font-size-body);\n  font-weight: var(--font-weight-semibold);\n  font-family: var(--font-body);\n  color: var(--color-fire-600);\n  text-decoration: none;\n  cursor: pointer;\n  transition: color var(--transition-fast);\n  flex: 1 1 auto;\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.event-card-organizer a:hover {\n  color: var(--color-fire-700);\n  text-decoration: underline;\n}\n\n/* Participants list */\n.event-card-participants {\n  margin-top: var(--space-3);\n}\n\n.participants-header {\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--color-text-primary);\n  margin-bottom: var(--space-2);\n  padding: 0 var(--space-2);\n}\n\n.participants-list {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-1);\n}\n\n.participant-item {\n  display: flex;\n  align-items: center;\n  gap: var(--space-3);\n  padding: 12px 16px;\n  border-radius: 12px;\n  background: var(--color-parchment-100);\n  border: 2px solid var(--color-wood-600);\n  box-shadow: 0 2px 4px rgba(45, 31, 16, 0.1);\n  transition: all 0.2s ease;\n}\n\n.participant-item--confirmed {\n  border-color: var(--color-wood-800);\n  background: linear-gradient(135deg, #e8dcc8 0%, #d4c4a8 100%);\n  box-shadow: 0 2px 8px rgba(109, 76, 41, 0.35);\n}\n\n.participant-item--pending {\n  border-color: var(--color-warning-600);\n  background: linear-gradient(135deg, #fdf8ed 0%, #fef5e7 100%);\n  box-shadow: 0 2px 8px rgba(212, 167, 74, 0.2);\n}\n\n.participant-item--empty {\n  background: var(--color-wood-50);\n  border-color: var(--color-wood-500);\n  border-style: dashed;\n  color: var(--color-text-secondary);\n  box-shadow: none;\n}\n\n.participant-item--joinable {\n  cursor: pointer;\n}\n\n.participant-item--joinable:hover {\n  background: linear-gradient(135deg, #e8f5ea 0%, #d4ead6 100%);\n  border-color: var(--color-nature-700);\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(74, 124, 89, 0.3);\n}\n\n.participant-icon {\n  font-size: 20px;\n  line-height: 1;\n  flex-shrink: 0;\n  width: 28px;\n  height: 28px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(109, 76, 41, 0.15);\n  border-radius: 50%;\n  border: 2px solid var(--color-wood-700);\n  color: var(--color-wood-900);\n  font-weight: 900;\n}\n\n.participant-icon--empty {\n  background: transparent;\n  border: none;\n  color: var(--color-wood-600);\n}\n\n.participant-name {\n  flex: 1;\n  min-width: 0;\n  font-size: 15px;\n  font-weight: 600;\n  color: var(--color-text-primary);\n  font-family: var(--font-body);\n}\n\n.participant-action-btn {\n  padding: 6px 16px;\n  font-size: 13px;\n  font-weight: 700;\n  color: var(--color-wood-900);\n  background: #c4a570;\n  border: 2px solid var(--color-wood-700);\n  border-radius: 20px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  font-family: var(--font-heading);\n  box-shadow: 0 2px 6px rgba(109, 76, 41, 0.35);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n}\n\n.participant-action-icon {\n  display: none;\n}\n\n.participant-action-btn:hover {\n  background: var(--color-danger-100);\n  transform: translateY(-1px);\n  box-shadow: 0 4px 8px rgba(168, 52, 42, 0.3);\n}\n\n.participant-action-btn--confirm {\n  color: var(--color-nature-900);\n  border-color: var(--color-nature-500);\n  background: #268d49;\n  box-shadow: 0 2px 4px rgba(30, 105, 52, 0.3);\n}\n\n.participant-action-btn--confirm:hover {\n  background: #166b32;\n  box-shadow: 0 4px 8px rgba(8, 63, 24, 0.3);\n}\n\n.participant-action-btn--leave {\n  border-color: var(--color-wood-700);\n  background: linear-gradient(135deg, #f5ede3, #e8dcc8);\n  color: var(--color-wood-900);\n}\n\n.participant-action-btn--leave:hover {\n  background: linear-gradient(135deg, #e8dcc8, #d4c4a8);\n}\n\n/* Remove participant button (for organizers/admins) */\n.participant-remove-btn {\n  width: 28px;\n  height: 28px;\n  margin-left: auto;\n  border-radius: 50%;\n  border: 2px solid #8b2e0b;\n  background: linear-gradient(135deg, #c53030, #a02020);\n  color: #ffffff;\n  font-size: 18px;\n  font-weight: 900;\n  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.8);\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.4);\n  cursor: pointer;\n  transition: all 0.2s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n  flex-shrink: 0;\n}\n\n.participant-remove-btn:hover {\n  background: linear-gradient(135deg, #a02020, #8b1a1a);\n  transform: scale(1.1);\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.5);\n}\n\n.participant-remove-btn:active {\n  transform: scale(0.95);\n}\n\n/* Invite button with AddFighterIcon */\n.event-invite-btn {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  border: 2px solid var(--color-fire-700);\n  background: linear-gradient(135deg, var(--color-fire-100), var(--color-fire-200));\n  color: var(--color-fire-800);\n  cursor: pointer;\n  transition: all 0.2s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n  box-shadow: 0 2px 6px rgba(179, 111, 66, 0.35);\n}\n\n.event-invite-btn:hover {\n  background: linear-gradient(135deg, var(--color-fire-200), var(--color-fire-300));\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(212, 129, 74, 0.5);\n}\n\n.event-invite-btn:active {\n  transform: translateY(0);\n}\n\n.event-invite-btn svg {\n  fill: var(--color-fire-700);\n}\n\n/* Copy-link button */\n.event-copy-link-btn {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  border: 2px solid var(--color-wood-600);\n  background: linear-gradient(135deg, #f5ede3, #e8dcc8);\n  color: var(--color-wood-900);\n  cursor: pointer;\n  transition: all 0.2s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n  box-shadow: 0 2px 6px rgba(109, 76, 41, 0.35);\n}\n\n.event-copy-link-btn:hover {\n  background: linear-gradient(135deg, #e8dcc8, #d4c4a8);\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(109, 76, 41, 0.5);\n}\n\n.event-copy-link-btn:active {\n  transform: translateY(0);\n}\n\n/* Edit button */\n.event-edit-btn {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  border: 2px solid var(--color-wood-600);\n  background: linear-gradient(135deg, #f5ede3, #e8dcc8);\n  color: var(--color-wood-900);\n  font-size: 20px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n  box-shadow: 0 2px 6px rgba(109, 76, 41, 0.35);\n}\n\n.event-edit-btn:hover {\n  background: linear-gradient(135deg, #e8dcc8, #d4c4a8);\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(109, 76, 41, 0.5);\n}\n\n.event-edit-btn:active {\n  transform: translateY(0);\n}\n\n/* Delete button */\n.event-delete-btn {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  border: 2px solid #e96609;\n  background: linear-gradient(135deg, #f7e8dd, #f0d9c5);\n  color: #000000;\n  font-size: 18px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n  box-shadow: 0 2px 6px rgbattbFormHeaderTitle(139, 76, 41, 0.35);\n}\n\n.event-delete-btn:hover {\n  background: linear-gradient(135deg, #f0d9c5, #e8cbb0);\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(139, 76, 41, 0.5);\n}\n\n.event-delete-btn:active {\n  transform: translateY(0);\n}\n\n@media (max-width: 425px) {\n  .event-card-header-content {\n    gap: var(--space-1);\n  }\n\n  .event-card-actions {\n    gap: 6px;\n    flex: 1 1 auto;   \n    margin-left: 0;\n    justify-content: flex-end;\n  }\n\n  .event-copy-link-btn,\n  .event-invite-btn,\n  .event-edit-btn,\n  .event-delete-btn {\n    width: 32px;\n    height: 32px;\n    border-width: 1px;\n  }\n\n  .event-copy-link-btn svg,\n  .event-invite-btn svg {\n    width: 18px;\n    height: 18px;\n  }\n\n  .event-edit-btn {\n    font-size: 16px;\n  }\n\n  .event-delete-btn {\n    font-size: 14px;\n  }\n\n  .event-card-organizer {\n    margin-bottom: var(--space-2);\n    padding: var(--space-1) 0;\n  }\n\n  .organizer-name {\n    font-size: var(--font-size-body-sm);\n  }\n\n  .participants-header {\n    font-size: 12px;\n    padding: 0 8px;\n  }\n\n  .participants-list {\n    gap: 6px;\n  }\n\n  .participant-item {\n    gap: 8px;\n    padding: 8px 10px;\n    border-width: 1px;\n    border-radius: 10px;\n    flex-wrap: nowrap;\n  }\n\n  .participant-icon {\n    width: 22px;\n    height: 22px;\n    font-size: 16px;\n    border-width: 1px;\n  }\n\n  .participant-name {\n    font-size: 13px;\n    min-width: 0;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    flex: 1 1 auto;\n  }\n\n  .participant-action-btn {\n    width: 32px;\n    height: 32px;\n    padding: 0;\n    font-size: 14px;\n    border-width: 1px;\n    border-radius: 50%;\n    box-shadow: 0 1px 3px rgba(109, 76, 41, 0.25);\n    flex: 0 0 auto;\n  }\n\n  .participant-action-text {\n    display: none;\n  }\n\n  .participant-action-icon {\n    display: inline-block;\n    line-height: 1;\n  }\n\n  .participant-remove-btn {\n    width: 24px;\n    height: 24px;\n    font-size: 14px;\n    border-width: 1px;\n  }\n}\n\n/* ---------- Wide layout: info on the left, game and participants on the right ---------- */\n\n/* Контейнер — только обёртка тела: container-type создаёт containing block для fixed-потомков,\n   а шторы подтверждения/приглашения живут внутри самой карточки. */\n.event-card-bodywrap {\n  container-type: inline-size;\n  container-name: event-card;\n}\n\n.event-card-col > :last-child {\n  margin-bottom: 0;\n}\n\n@container event-card (min-width: 720px) {\n  .event-card-body {\n    display: grid;\n    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);\n    column-gap: var(--space-5);\n    align-items: start;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
